// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76f64fd1","239":"e15bbefd","455":"8f03faa0"}[chunkId] + ".chunk.js";
};